// extracted by mini-css-extract-plugin
export var btn = "Demo-module--btn--7330a";
export var btnOutlinePrimary = "Demo-module--btn-outline-primary--00322";
export var btnPrimary = "Demo-module--btn-primary--fb939";
export var formSelect = "Demo-module--form-select--cd084";
export var video = "Demo-module--video--27995";
export var wrap = "Demo-module--wrap--c5d98";